export { default } from "./Client";



// WEBPACK FOOTER //
// ./src/containers/Private/pages/workflow-client/side-menu/Client/index.js